/** Per-resource staleTime values (ms) — stale-while-revalidate windows. */
export const STALE_TIMES = {
  default: 60_000,
  authMe: 5 * 60_000,
  documentsList: 60_000,
  documentsStats: 60_000,
  dashboardInsights: 90_000,
  planUsage: 2 * 60_000,
  billingPlans: 5 * 60_000,
  billingSubscription: 2 * 60_000,
  storageSummary: 60_000,
  storageDocuments: 60_000,
  creditPackages: 60_000,
  creditBalance: 15_000,
  creditHistory: 30_000,
  paymentMethods: 60_000,
  creditCosts: 60_000,
  planFeatures: 2 * 60_000,
  documentDetail: 30_000,
  deletionRequests: 30_000,
  notificationsUnread: 30_000,
  notificationsList: 30_000,
  conversationsList: 45_000,
  conversationMessages: 45_000,
  /** Session-length: readiness rarely changes; invalidate on preset/send-defaults mutations. */
  conversationReadiness: 30 * 60_000,
  protectionPresets: 60_000,
  settings: 2 * 60_000,
  supportTickets: 60_000,
  generationJob: 5_000,
  adminDashboard: 60_000,
  adminDocumentActivitySummary: 30_000,
  adminUsers: 45_000,
  adminTickets: 30_000,
  adminDocuments: 45_000,
  adminDefault: 60_000,
} as const;
